import { Box, MenuItem, Select } from '@mui/material';
import { CURRENCY_ICON, Currency } from '../../components/common/Form/config';

type Origin = 'from' | 'to';

export interface OnChangeCountryOptionsProps {
  origin: Origin;
  value: Currency;
}

interface SelectCurrencyOptionsProps {
  origin: Origin;
  currency: Currency;
  desCurrency: Currency;
  onChange: (params: OnChangeCountryOptionsProps) => void;
  currenciesOptions: { name: string; id: number }[];
}

const SelectCurrencyOptions = ({
  origin,
  currency,
  desCurrency,
  onChange,
  currenciesOptions,
}: SelectCurrencyOptionsProps) => (
  <Select
    id="select-currencies"
    sx={{
      boxShadow: 'none',
      '.MuiOutlinedInput-notchedOutline': { border: 0 },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '& > fieldset': { border: 'none !important' },
      border: 'none',
    }}
    value={origin === 'from' ? currency : desCurrency}
    label="Currency"
    onChange={(value) =>
      onChange({ origin, value: value.target.value as Currency })
    }
    renderValue={(value) => (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {CURRENCY_ICON[value]}
        {value}
      </Box>
    )}
  >
    {currenciesOptions.map((currencyOption) => (
      <MenuItem
        disabled={
          (currency === currencyOption.name && origin === 'to') ||
          (desCurrency === currencyOption.name && origin === 'from')
        }
        key={currencyOption.id}
        value={currencyOption.name}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {CURRENCY_ICON[currencyOption.name as keyof typeof CURRENCY_ICON]}{' '}
          {currencyOption.name}
        </div>
      </MenuItem>
    ))}
  </Select>
);

export default SelectCurrencyOptions;
